import { useState, useMemo } from "react";
import { ORDERS_API } from "../../../../Utilities/APIs/APIs";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";

import SelectInput from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import SwitchInput from "../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";
import Form from "../../../Partials/Layouts/Forms/Form";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";

function ChangeOrderedProductStatus({
  setShowChangeOrderedProductStatus,
  orderID,
  targetID,
  triggerFetch,
  orderItem,
}) {
  const axiosInstance = useAxiosInstance();

  const [itemStatus, setItemStatus] = useState(orderItem?.itemStatus || "");
  const [proceedWithoutScan, setProceedWithoutScan] = useState(false);
  const [loading, setLoading] = useState(false);

  const shippingStatuses = [
    "dispatchedInHouse",
    "dispatchedCourier",
    "delivered",
    "deliveredUnpaid",
  ];

  const effectiveOrdered = useMemo(() => {
    const qty = Number(orderItem?.quantity || 0);
    let cancelled = Number(orderItem?.cancelQuantity || 0);

    if (!cancelled && orderItem?.isCancelled) {
      cancelled = qty;
    }

    return Math.max(0, qty - cancelled);
  }, [orderItem]);

  const scannedQuantity = Number(orderItem?.scannedQuantity || 0);
  const isFullyScanned = scannedQuantity >= effectiveOrdered;
  const selectedNeedsScan = shippingStatuses.includes(itemStatus);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!itemStatus) return;

    try {
      setLoading(true);

      await axiosInstance.patch(
        `${ORDERS_API}cancelSingleOrderItem/${orderID}/${targetID}`,
        {
          itemStatus,
          allowWithoutScan: selectedNeedsScan ? proceedWithoutScan : false,
        }
      );

      triggerFetch();
      setShowChangeOrderedProductStatus(false);
    } catch (err) {
      console.error("change ordered product status error", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div
          style={{
            fontSize: "12px",
            marginBottom: "12px",
            lineHeight: 1.6,
            color: "#fff",
          }}
        >
          <div>
            <strong>Product:</strong> {orderItem?.item?.name}
          </div>
          <div>
            <strong>Size:</strong> {orderItem?.size?.name}
          </div>
          <div>
            <strong>Ordered:</strong> {orderItem?.quantity}
          </div>
          <div>
            <strong>Scanned:</strong> {scannedQuantity}
          </div>
          <div>
            <strong>Active Qty:</strong> {effectiveOrdered}
          </div>
        </div>

        <SelectInput
          label={"Ordered Product Status"}
          value={itemStatus}
          setState={setItemStatus}
        >
          <SelectOption optionValue="" optionText="Select Status" />
          <SelectOption optionValue="pending" optionText="Pending" />
          <SelectOption
            optionValue="dispatchedInHouse"
            optionText="Dispatched (InHouse)"
          />
          <SelectOption
            optionValue="dispatchedCourier"
            optionText="Dispatched (Courier)"
          />
          <SelectOption optionValue="delivered" optionText="Delivered" />
          <SelectOption
            optionValue="deliveredUnpaid"
            optionText="Delivered (Unpaid)"
          />
          <SelectOption optionValue="refunded" optionText="Refunded" />
          <SelectOption optionValue="exchanged" optionText="Exchanged" />
          <SelectOption optionValue="canceled" optionText="Canceled" />
        </SelectInput>

        {selectedNeedsScan && !isFullyScanned && (
          <>
            <p
              style={{
                marginTop: "8px",
                marginBottom: "15px",
                color: "#ffb74d",
                fontSize: "13px",
              }}
            >
              This ordered product is not fully scanned yet. Scan &amp; Pack it
              first before moving to dispatch/delivery.
            </p>

            <SwitchInput
              label={`Proceed Without Scan?`}
              toggleSwitch={() => setProceedWithoutScan((prev) => !prev)}
              checked={proceedWithoutScan}
            />
          </>
        )}

        <FormSubmitButton
          text={loading ? "SUBMITTING..." : "SUBMIT"}
          disabled={!itemStatus || loading}
        />
      </Form>
    </div>
  );
}

export default ChangeOrderedProductStatus;